import { useEffect } from 'react'
import AmDashboard from "./AccountManager/AmDashboard"
import DealerDashboard from "./Dealer/DealerDashboard"
import VCIDashboard from './VCI/VCIDashboard'
import Login from "./Login"
import useStore from "../store"
import { vciPortalEnabled } from '../utilities/featureFlags'
import useUserType from '../hooks/useUserType'

export default function Dashboard() {
  const { isLoggedIn, isAccountManager, isVCI, isDealer } = useUserType()
  const setNavBarHidden = useStore((state) => state.setNavBarHidden)
  const setTopNavHidden = useStore((state) => state.setTopNavHidden)

  useEffect(() => {
    setNavBarHidden(false)
    setTopNavHidden(false)
  })

  if (isLoggedIn) {
    if (isAccountManager) {
      return <AmDashboard />
    } else if (isDealer) {
      return <DealerDashboard/>
    } else if (isVCI && vciPortalEnabled) {
      return <VCIDashboard />
    }
  }

  return <Login />
}
